<div style="position: fixed; inset: 0; z-index: 1055; display: block;">
  <div class="modal fade show" tabindex="-1" role="dialog" style="display: block; position: absolute; inset: 0;">
    <div class="modal-backdrop fade show" style="position: absolute; inset: 0; background-color: rgba(0,0,0,0.5);">
    </div>

    <div class="modal-dialog modal-dialog-centered mx-3 mx-sm-auto" role="document"
      style="position: relative; z-index: 1056;">
      <div class="modal-content rounded-4 shadow">

        <div class="modal-header border-bottom-0 pb-0">
          <h5 class="modal-title fw-bold">{{ ticketType.name }}</h5>
          <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()"></button>
        </div>

        <div class="modal-body pt-0">

          <!-- Quantity Selector -->
          <div class="d-flex align-items-center justify-content-center my-4">
            <button type="button"
              class="btn btn-outline-secondary rounded-circle p-0 d-flex align-items-center justify-content-center touch-target"
              (click)="decreaseQty()" [disabled]="qty <= 1">
              <span class="material-symbols-outlined">remove</span>
            </button>

            <div class="mx-3 text-center d-flex align-items-baseline gap-2">
              <span class="fs-4 fw-bold">{{ qty }}</span>
              <span class="text-muted">ticket{{ qty > 1 ? 's' : '' }}</span>
            </div>

            <button type="button"
              class="btn btn-outline-secondary rounded-circle p-0 d-flex align-items-center justify-content-center touch-target"
              (click)="increaseQty()">
              <span class="material-symbols-outlined">add</span>
            </button>
          </div>

          <!-- Amount Input -->
          <div class="mb-4" [formGroup]="donationForm">
            <label for="donation" class="form-label fw-bold">Monto de Donación (por ticket)</label>
            <div class="input-group unified-input-group">
              <span class="input-group-text">RD$</span>
              <input type="text" class="form-control" id="donation" formControlName="amount" placeholder="0.00"
                mask="separator.2" thousandSeparator="," decimalMarker="." (blur)="onBlurAmount()">
            </div>
            <div class="form-text small-text">Donación mínima: RD${{ minAmount | number:'1.2-2' }} por ticket</div>
          </div>

          <!-- Summary Card -->
          <div class="card bg-white custom-card-shadow">
            <div class="card-body">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Cantidad:</span>
                <span class="fw-bold">{{ qty }}</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-muted">Por ticket:</span>
                <span class="fw-bold">RD${{ amount | number:'1.2-2' }}</span>
              </div>
              <hr class="my-2 custom-hr">
              <div class="d-flex justify-content-between">
                <span class="fw-bold">Total de Donación:</span>
                <span class="fs-5 fw-bold">RD${{ total | number:'1.2-2' }}</span>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-footer border-top-0 pt-0">
          <button type="button" class="btn btn-outline-dark rounded-pill px-4 btn-cancel-custom"
            (click)="onClose()">Cancelar</button>
          <button type="button" class="btn btn-dark rounded-pill px-4 btn-confirm-custom" (click)="onConfirm()"
            [disabled]="donationForm.invalid">Confirmar Donación</button>
        </div>

      </div>
    </div>
  </div>
</div>